import React from 'react'
import LottiLoader from 'components/shared/Loader/LottiLoader'

const AddressAutoSplash = () => {
  return (
    // <div className='splace_screen d-flex d-md-none'>
    <div className='splace_screen d-flex '>
      {/* <div>
        <AddressFetchLoader />
        <p>We are fetching your location</p>
      </div> */}
      <LottiLoader loader={true} />
    </div>
  )
}

export default AddressAutoSplash
